import React, {useEffect, useState} from 'react';
import { useBarcode } from 'react-barcodes';
import useToken from "../useToken";
import {inventarioResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";

function DialogPass() {
    const [value, setValue] = useState(null);
    const getPassSupervision = ()=>{
        const datos = useToken.getDatos();
        const idCliente = datos.id_cliente;
        inventarioResources.getPassSupervision(idCliente).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                setValue(result.message);
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });

    }
    const { inputRef } = useBarcode({
        value: value,
        options: {
            background: '#FFFFFF',
        }
    });

    useEffect(()=>{
        getPassSupervision()
    }, []);

    return <Grid container direction={"column"} alignItems={"center"} >
        <svg ref={inputRef} />
    </Grid>;
}

export default DialogPass;